import { Controller, Post, Body, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { OverTimeCatDTO } from './dto/overtime-category.dto';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { AllOverTimeCategoriesResponse, OverTimeCategoryResponse } from '@gtpl/shared-models/hrms';
import { OverTimeCatRequest } from './dto/overtime-category.request';
import { OvertimeCategoryService } from './overtime-category.service';

@ApiTags('overtime-category')
@Controller('overtime-category')
export class OvertimeCategoryController {
    constructor(
        private service: OvertimeCategoryService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createOverTimeCat')
    async createOverTimeCat(@Body() DTO: OverTimeCatDTO, isUpdate: boolean = false ): Promise<OverTimeCategoryResponse>{
        try{
            return await this.service.createOverTimeCategory(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(OverTimeCategoryResponse, error);
        }
    }

    @Post('/updateOverTimeCat')
    async updateOverTimeCat(@Body() DTO: OverTimeCatDTO, isUpdate: boolean = false ): Promise<OverTimeCategoryResponse>{
        try{
            return await this.service.createOverTimeCategory(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(OverTimeCategoryResponse, error);
        }
    }

    @Post('/getAllOverTimeCategories')
    async getAllOverTimeCategories(): Promise<AllOverTimeCategoriesResponse>{
        try{
            return await this.service.getAllOverTimeCats();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllOverTimeCategoriesResponse, error);
        }
    }

    @Post('/getAllActiveOverTimeCats')
    async getAllActiveOverTimeCats(): Promise<AllOverTimeCategoriesResponse>{
        try{
            return await this.service.getAllActiveOverTimeCats();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllOverTimeCategoriesResponse, error);
        }
    }

    @Post('/activateOrDeactivate')
    async activateOrDeactivate(@Body() catReq: OverTimeCatRequest): Promise<OverTimeCategoryResponse>{
        try{
            return await this.service.activateOrDeactivateCategory(catReq);
        }catch(error){
            return this.applicationExceptionHandler.returnException(OverTimeCategoryResponse, error)
        }
    }
}
